export { default as ProductNameDS } from './product-name-ds'
export type { ProductNameDSProps, ProductNameDSVariant } from './product-name-ds'
